module.exports = __webpack_public_path__ + "media/BeJ.2d300b1e.mp4";